module.exports = __webpack_public_path__ + "img/mauritania.328d3939.svg";